export const getAllETO = (obj) => ({
  type: "GET_ALL_ETO",
  obj,
});

export const getAllETOSuccess = (data) => ({
  type: "GET_ALL_ETO_SUCCESS",
  data,
});

export const getAllETOFail = (error) => ({
  type: "GET_ALL_ETO_FAIL",
  error,
});

export const addETO = (obj) => ({
  type: "ADD_ETO",
  obj,
});

export const addETOSuccess = (data) => ({
  type: "ADD_ETO_SUCCESS",
  data,
});

export const addETOFail = (error) => ({
  type: "ADD_ETO_FAIL",
  error,
});

export const resetAddETO = () => ({
  type: "RESET_ADD_ETO",
});

export const getEtoOrTiDetails = (obj) => ({
  type: "GET_ETO_OR_TI_DETAILS",
  obj,
});

export const getEtoOrTiDetailsSuccess = (data) => ({
  type: "GET_ETO_OR_TI_DETAILS_SUCCESS",
  data,
});

export const getEtoOrTiDetailsFail = (error) => ({
  type: "GET_ETO_OR_TI_DETAILS_FAIL",
  error,
});

export const getEtoOfDistrict = (obj) => ({
  type: "GET_ETO_OF_DISTRICT",
  obj,
});

export const getEtoOfDistrictSuccess = (data) => ({
  type: "GET_ETO_OF_DISTRICT_SUCCESS",
  data,
});

export const getEtoOfDistrictFail = (error) => ({
  type: "GET_ETO_OF_DISTRICT_FAIL",
  error,
});


export const updateETO = (obj) => ({
  type: "UPDATE_ETO",
  obj,
});

export const updateETOSuccess = (data) => ({
  type: "UPDATE_ETO_SUCCESS",
  data,
});

export const updateETOFail = (error) => ({
  type: "UPDATE_ETO_FAIL",
  error,
});


export const resetUpdateETO = () => ({
  type: "RESET_UPDATE_ETO",
});